import { faCancel, faRightFromBracket } from '@fortawesome/pro-solid-svg-icons';
import { withTranslation } from 'react-i18next';

import Button from '../../components/Atoms/Button';
import ButtonsContainer from '../../components/Atoms/ButtonsContainer';
import Heading from '../../components/Atoms/Heading';

const SignOutWindow = ({ t, onSignOut = () => { }, onCancel = () => { } }) => {
    return (
        <>
            <Heading h={1} center>
                {t('Are you sure you want to sign out?')}
            </Heading>
            <Heading h={6} center>
                {t('You will be able to sign in again using your login and password')}
            </Heading>
            <br />
            <ButtonsContainer position="CENTER">
                <Button icon={faCancel} action={onCancel} label={t('No, cancel')} />
                <Button icon={faRightFromBracket} action={onSignOut} label={t('Yes, sign out')} />
            </ButtonsContainer>
        </>
    );
};

export default withTranslation()(SignOutWindow);
